import { AfterViewChecked, Component, OnInit, ViewEncapsulation} from '@angular/core';
import { Router } from '@angular/router';
import { CommonDataService } from 'src/app/common/services/common-data.service';
import { GraphqlService } from '../../common/services/graphql.service';
import { HttpcallService } from '../../common/services/httpcall.service';
import { LoginService } from '../../common/services/Login.service';
import { OpenLinkById } from '../../common/services/openlinkbyid';
import { DomSanitizer } from '@angular/platform-browser';
import { forkJoin } from 'rxjs';
import { constObj } from '../../common/Constants/constants';
import { SessionService } from '../../common/services/Session.service';


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class HomeComponent implements OnInit, AfterViewChecked {
  UserContent;
  generalFeedbacklink: string;
  constructor(
    public commonDataService: CommonDataService,
    public loginService: LoginService, private graphQlService: GraphqlService, private httpCallService: HttpcallService,
    private route: Router,
    private openlink: OpenLinkById,
    private sanitizer: DomSanitizer, private session: SessionService
  ) {
  }
  resetPassword: string = "";
  header: string = "";
  description;
  aboutCodificationHeader: string = "";
  history: string = "";
  historyDesc: string = "";
  completeHistory: string = "";
  bookmark: string = "";
  bookmarkDesc: string = "";
  viewAllBookmark: string = "";
  whatsNew: string = "";
  whatsNewDesc: string = "";
  helpTitle: string = "";
  helpDescription: string = "";
  whatIsCod: string = "";
  whatIsCodDesc: string = "";
  faq: any;
  home_NewLaunch;
  whatsNewBody: string = "";
  helpTopics: any;
  accessType: string = "";
  howToUse: string = "";
  howToUseDesc: string = "";
  basicUserGuide: any;
  proUserGuide: any;
  aboutCod: any;
  howToUseCod: string = "";
  basicViewUserPdfName: string = "";
  howToUseCodFileName: string = "";
  generalFeedback: any;
  pastUpdateLink;
  recentDocLink;
  userAccountId: string = "";
  userId: string = "";
  newUser: boolean = true;
  myHistory: any;
  topBookmark;
  basicView: boolean = false;
  outcome: boolean = false;
  licenseeView: boolean = false;
  licenseeTitle: string = "Licensee";
  FasbbaseUrl: string = "";
  homelabels: any;
  s3baseurl: string;
  whatsnewbodymulti;
  fasbLink: string = "";
  whatsnewobj: any;
  maintenanceFlag: boolean = false;
  maintenanceMessage: string = "";
  ngOnInit(): void {
    this.firstTimeFlag = true;
    this.commonDataService.showLoader.next(true);
    this.checkSession();
    const isContactUsRoute = this.route.url?.includes('contact-us');
    if (isContactUsRoute) {
      this.openRightOverlayForContactUs();
    }
  }

  openRightOverlayForContactUs() {
    setTimeout(() => {
      this.commonDataService.rightPanelWidth.next("rightOverLay_small");
      this.commonDataService.rightOverlayOption.next("General Feedback");
      this.commonDataService.showRightPanel.next(true);
    }, 1500);
  }

  userInfo: any;
  checkSession() {
    if (this.session.userInfo == undefined || this.session.userInfo.user == null) {
      this.loginService.getSession().subscribe(data => {
        this.session.assignUserInfo(data.user);
        this.HomePageHttpCalls(data);
        this.userInfo = data.user;
      })
    }
    else {
      this.userInfo = this.session.userInfo.user;
      this.HomePageHttpCalls(this.session.userInfo);
    }
  }
  name;
  HomePageHttpCalls(data) {
    if (data.user.roles == "Basic") {
      this.accessType = "Basic";
      this.basicView = true;
      forkJoin([
        this.graphQlService.getHomePageComponents(), this.graphQlService.getGASBLink()
      ]).subscribe(([homePageLabels, fasbLink]) => {
        this.fasbLink = fasbLink;
        var whatlinkshere = homePageLabels?.filter(x => x.customMetas.edges.some(y => y.node.value == "Pdflinkwhatsnewhere"));
        var home = homePageLabels?.filter(x => x.customMetas.edges.some(y => y.node.value == "HomePageLabels"));
        var helpComp = homePageLabels?.filter(x => x.customMetas.edges.some(y => y.node.value == "HomePageHelpComponent"));
        this.getHomePageLabel(home); this.getWhatsNewcontent(whatlinkshere); this.getHelpComp(helpComp);
        this.outcome = true; this.commonDataService.showLoader.next(false);
      }, err => { console.log(err); this.commonDataService.showLoader.next(false); });
    }
    else if (data.user.roles == "Professional") {
      this.basicView = false;
      this.accessType = "Professional";
      this.userAccountId = data.user.email;
      this.userId = data.user.firstname+" "+data.user.lastname;// != ""? data.user.userName :  data.user.email;
      this.newUser = false;
      this.commonDataService.emailId.next(data.user.email);
      if (!this.newUser) {
        forkJoin([
          //this.graphQlService.getMySubscriptionInformation(),
          this.graphQlService.getHomePageComponents(),
          this.httpCallService.getTopAnnotation(),
          this.httpCallService.getMyHistory(),
          this.httpCallService.getTopBookmark(),
          this.graphQlService.getGASBLink()
          //this.graphQlService.getTimeforHttpcalls()
        ]).subscribe(([homePageLabels, myAnnotation, myHistory, myBookmark, fasbLink]) => {
          this.fasbLink = fasbLink;
          this.licenseeView = false;
          var whatlinkshere = homePageLabels?.filter(x => x.customMetas.edges.some(y => y.node.value == "Pdflinkwhatsnewhere"));
          var home = homePageLabels?.filter(x => x.customMetas.edges.some(y => y.node.value == "HomePageLabels"));
          var helpComp = homePageLabels?.filter(x => x.customMetas.edges.some(y => y.node.value == "HomePageHelpComponent"));
          this.getHomePageLabel(home); this.getWhatsNewcontent(whatlinkshere); this.getHelpComp(helpComp);
          this.getTopAnnotationHistoryCombination(myHistory, myAnnotation); this.getTopBookmark(myBookmark);
          // this.setLocalstorageforTimer(timerdata);
          this.outcome = true; this.commonDataService.showLoader.next(false)
        }, err => {
          let obj = {
            type: 'error',
            displayTime: 10000,
            position: 'bottom',
            message: constObj.microserviceFailureOnHomePage
          }
          this.commonDataService.notificationObject.next(obj);
          this.outcome = true;
          console.log(err); this.commonDataService.showLoader.next(false);
        });
      }
      else {
        forkJoin([
          this.graphQlService.getHomePageComponents()
        ]).subscribe(([homePageLabels]) => {
          var whatlinkshere = homePageLabels?.filter(x => x.customMetas.edges.some(y => y.node.value == "Pdflinkwhatsnewhere"));
          var home = homePageLabels?.filter(x => x.customMetas.edges.some(y => y.node.value == "HomePageLabels"));
          var helpComp = homePageLabels?.filter(x => x.customMetas.edges.some(y => y.node.value == "HomePageHelpComponent"));
          this.getHomePageLabel(home); this.getWhatsNewcontent(whatlinkshere); this.getHelpComp(helpComp);
          this.outcome = true; this.commonDataService.showLoader.next(false);
        }, err => { console.log(err); this.outcome = true; this.commonDataService.showLoader.next(false); });
      }
    }
  }
  //setLocalstorageforTimer(timerdata) {
  //  localStorage.setItem("httpcallsdata", JSON.stringify(timerdata.timervalues));
  //}
  howToUseDescArr1: string = "";
  helpTopicText: string = "";
  howToUseDescArr2: string = "";
  proViewUserGuide: any;
  howToUseDescArr3: string = "";
  help_navigation;
  getHomePageLabel(data) {
    if (data != "" && data != undefined) {
      this.homelabels = data[0].content.data.labels;
      var labels = data[0].content.data.labels;
      labels = labels.filter(x => x.key.trim());
      this.description = this.sanitizer.bypassSecurityTrustHtml(labels.filter(x => x.key == "home_headerDsicription").map(y => y.value));
      this.FasbbaseUrl = labels.filter(x => x.key == "fasbbase_url").map(y => y.value);
      this.help_navigation = labels.filter(x => x.key == "navigation_help").map(y => y.value);
      this.resetPassword = labels.filter(x => x.key == "resetPasswordLabel").map(y => y.value);
      this.history = labels.filter(x => x.key == "home_history").map(y => y.value);
      this.aboutCodificationHeader = labels.filter(x => x.key == "home_aboutCodificationHeader").map(y => y.value);
      this.historyDesc = labels.filter(x => x.key == "home_historyDescription").map(y => y.value);
      this.completeHistory = labels.filter(x => x.key == "home_completeHistory").map(y => y.value);
      this.bookmark = labels.filter(x => x.key == "home_bookmarks").map(y => y.value);
      this.bookmarkDesc = labels.filter(x => x.key == "home_bookmarksDescription").map(y => y.value);
      this.viewAllBookmark = labels.filter(x => x.key == "home_allBookmarks").map(y => y.value);
      this.whatsNew = labels.filter(x => x.key == "home_whatNew").map(y => y.value);
      this.whatsNewDesc = labels.filter(x => x.key == "home_whatNewDescription").map(y => y.value);
      this.helpTitle = labels.filter(x => x.key == "home_helpTitle").map(y => y.value);
      this.helpDescription = labels.filter(x => x.key == "home_helpDescription").map(y => y.value);
      this.whatIsCod = labels.filter(x => x.key == "home_headerWhatIsCod").map(y => y.value);
      this.whatIsCodDesc = labels.filter(x => x.key == "home_descriptionWhatIsCod").map(y => y.value);
      this.howToUse = labels.filter(x => x.key == "home_headerHowToUse").map(y => y.value);
      this.whatsNewBody = labels.filter(x => x.key == "home_whatsNew_Body").map(y => y.value);
      this.pastUpdateLink = this.sanitizer.bypassSecurityTrustHtml(labels.filter(x => x.key == "home_viewPastUpdates_link").map(y => y.value));
      this.recentDocLink = this.sanitizer.bypassSecurityTrustHtml(labels.filter(x => x.key == "home_viewRecentDocs_link").map(y => y.value));
      this.maintenanceMessage = labels.filter(x => x.key == "maintenanceMessage").map(y => y.value);
      this.maintenanceFlag = labels.filter(x => x.key == "maintenanceflag").map(x => x.value.toLowerCase() === "true")[0];
      // this.faq = this.sanitizer.bypassSecurityTrustHtml(labels.filter(x => x.key == "home_FAQ").map(y => y.value));
      // this.helpTopics = labels.filter(x => x.key == "home_helpTopics").map(y => y.value);
      // this.basicUserGuide = this.sanitizer.bypassSecurityTrustHtml(labels.filter(x => x.key == "home_basicUserGuide").map(y => y.value));
      // this.proUserGuide = this.sanitizer.bypassSecurityTrustHtml(labels.filter(x => x.key == "home_proUserGuide").map(y => y.value));
      // this.aboutCod = this.sanitizer.bypassSecurityTrustHtml(labels.filter(x => x.key == "home_aboutCod").map(y => y.value));
      this.howToUseCod = labels.filter(x => x.key == "home_howToUseCod").map(y => y.value);
      this.basicViewUserPdfName = labels.filter(x => x.key == "home_basicViewUserPdfName").map(y => y.value);
      this.howToUseCodFileName = labels.filter(x => x.key == "home_howToUseCod_pdfFileName").map(y => y.value);
      // this.generalFeedback = "General Feedback";
      if (this.accessType == "Basic") {
        this.header = labels.filter(x => x.key == "home_headerWelcomeBasicView").map(y => y.value);
        this.howToUseDesc = labels.filter(x => x.key == "home_descriptionHowToUseBasic").map(y => y.value);
        this.home_NewLaunch = this.sanitizer.bypassSecurityTrustHtml(labels.filter(x => x.key == "home_NewLaunch").map(y => y.value));
        this.howToUseDescArr1 = this.howToUseDesc[0].toString().split("[Help_Topics_link]")[0];
        this.helpTopicText = "Help Topics";
        this.howToUseDescArr2 = this.howToUseDesc[0].toString().split("[Help_Topics_link]")[1].split("[User_Guide]")[0];
        this.proViewUserGuide = "User Guide";
        this.howToUseDescArr3 = this.howToUseDesc[0].toString().split("[Help_Topics_link]")[1].split("[User_Guide]")[1];
      }
      else if (this.accessType == "Professional" || this.accessType == "Academic") {
        this.howToUseDesc = labels.filter(x => x.key == "home_descriptionHowToUsePro").map(y => y.value);
        this.home_launchmessage = this.sanitizer.bypassSecurityTrustHtml(labels.filter(x => x.key == "home_launchmessage").map(y => y.value));
        this.howToUseDescArr1 = this.howToUseDesc[0].toString().split("[Help_Topics_link]")[0];
        this.helpTopicText = "Help Topics";
        this.howToUseDescArr2 = this.howToUseDesc[0].toString().split("[Help_Topics_link]")[1].split("[Pro_View_User_Guide_Link]")[0];
        this.proViewUserGuide = "User Guide";
        this.howToUseDescArr3 = this.howToUseDesc[0].toString().split("[Help_Topics_link]")[1].split("[Pro_View_User_Guide_Link]")[1];
        this.header = labels.filter(x => x.key == "home_headerWelcome").map(y => y.value);
        this.header = this.header.toString().replace("[USER_NAME]", this.userId);
      }

    }
  }
  home_launchmessage;
  getTopAnnotationHistoryCombination(myHistory: any, myAnnotation: any) {
    this.myHistory = [];
    this.myHistory.push.apply(this.myHistory, myHistory);
    this.myHistory.push.apply(this.myHistory, myAnnotation);
    this.myHistory.sort((a: any, b: any) => {
      return (new Date(a.recentDate).getTime()) - (new Date(b.recentDate).getTime());
    });
    this.myHistory = this.myHistory.reverse().slice(0, 5);
  }

  getTopBookmark(myBookmark) {
    this.topBookmark = myBookmark;
  }

  whatsNewContent: any;

  abc: any;
  paragraphs: string[];
  whatsNewObject = [];
  whatsNewParas: any;
  getWhatsNewcontent(whatNewContent: any) {
    if (whatNewContent != null) {
      this.whatsNewObject = [];
      this.whatsnewbodymulti = whatNewContent[0].content?.data?.pdfLink;

        for (var i = 0; i < this.whatsnewbodymulti.length; i++) {
          this.whatsnewobj = this.whatsnewbodymulti[i];
          this.abc = { "pdfTitle": this.whatsnewobj.title, "pdfLink": this.whatsnewobj.pdffile.title, "fileName": this.whatsnewobj.linkText };
          this.whatsNewObject.push(this.abc);
        }
      }
  }

  ResetPassword() {
    this.commonDataService.showLoader.next(true);
    if (this.session.userInfo == undefined || this.session.userInfo.user == null) {
      this.loginService.getSession().subscribe(data => {
        this.session.assignUserInfo(data.user);
        this.commonDataService.showRightPanel.next(true);
        this.commonDataService.userData.next(data.user);
        this.commonDataService.rightPanelWidth.next("rightOverLay_small");
        this.commonDataService.rightOverlayOption.next("addUpdateUser");
      })
    }
    else {
      this.commonDataService.showRightPanel.next(true);
      this.commonDataService.userData.next(this.session.userInfo.user);
      this.commonDataService.rightPanelWidth.next("rightOverLay_small");
      this.commonDataService.rightOverlayOption.next("addUpdateUser");
    }
  }

  licensee: any;
  getHelpComp(data) {
    if (data != "" && data != undefined) {
      var labels = data[0].content.data;

      this.basicUserGuide = labels.helpBasicUserGuide;
      this.faq =labels.helpFaq;
      this.helpTopics = labels.helpTopics;
      this.proUserGuide = labels.helpProUserGuide;
      this.aboutCod = labels.helpaboutCod;
      this.generalFeedback=labels.helpGeneralFeedback;
      this.licensee=labels.helpLicenseeTitle;
      this.helpTopicText = this.helpTopics.linkText;
    }
  }

  ViewAllBookmark() {
    this.route.navigateByUrl("/myBookmarks");
  }
  NavigateToHelp() {
    this.route.navigateByUrl("/help");
  }

  NavigateToLicensee() {
    this.route.navigateByUrl("/Licensee");
  }

  ViewCompleteHistory() {
    this.route.navigateByUrl("/MyHistory");
  }

  redirectToBookmarkUrl(bookmark) {
    event.preventDefault();

    //let crumbData = bookmark.breadCrumb.toString().split('~');
    this.route.navigateByUrl(bookmark.pageURL);
  }

  redirectToHistoryUrl(history, event) {
    event.preventDefault();
    //let crumbData = history.breadCrumb.toString().split('~');
    this.route.navigateByUrl(history.pageURL);
  }

  addGeneralFeedback() {
    this.commonDataService.showRightPanel.next(true);
    this.commonDataService.rightPanelWidth.next("rightOverLay_small");
    this.commonDataService.rightOverlayOption.next(this.generalFeedback.linkTitle);
  }
  openLinkById(event, isSitesBucket = false) {
    event.preventDefault();
    this.openlink.openLinkById(event,isSitesBucket);
  }

  OpenLink(event) {
    event.preventDefault();
    let id = event.target.id;
    if (id != null) {
      window.open(this.fasbLink + id);
    }
  }

  addtabindex() {
    var items = document.getElementsByClassName("pdf-link");
    if (items != undefined) {
      for (var i = 0; i < items.length; i++) {
        let element = items[i];
        element.setAttribute("tabIndex", "0");

      }
    }

  }
  firstTimeFlag: boolean = true;
  ngAfterViewChecked() {
    if (this.firstTimeFlag) {
      this.addtabindex();
      this.firstTimeFlag = false;
    }
  }

  onRightClick(event, data?: any) {
    if (data != null && data != 'SitesPdf' && data != 'DocsPdf') {
      event.target.href = data.pageURL;
    }
    else {
      let id = event.target.getAttribute('id');
      if (id != null && id.trim()[0] === '/') {
        if (event.target.id.split('?')[1].includes('pageId')) {
          event.target.href = this.fasbLink+event.target.id;
        }
        else { event.target.href = event.target.id; }
      }
      else if ((id.includes('.')) && (id.split('.').pop() === 'pdf')) {
        let url="";
        if(data == 'SitesPdf'){
          url = '/layoutComponents/getPdf?isSitesBucket=' + true +'&fileName=' + id;//show pdf
        }
        else if(data=='DocsPdf'){
          url = '/layoutComponents/getPdf?isSitesBucket=' + false +'&fileName=' + id;//show pdf
        }
        
        event.target.href = url;
      }
      else {
        event.target.href = this.s3baseurl + "/" + event.target.id;
      }
    }
  }
}
